import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from './ConversationsStatusSwitch.scss';

ConversationsStatusSwitch.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    choices: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default function ConversationsStatusSwitch({ name, value, onChange, choices }) {
    const handleChange = useCallback(
        (e) => {
            onChange(e.target.value);
        },
        [onChange]
    );

    return (
        <div className={styles.root}>
            {choices.map((item, key) => (
                <label key={key} className={styles.label}>
                    <input
                        className={styles.input}
                        type="radio"
                        name={name}
                        value={item.value}
                        checked={value === item.value}
                        onChange={handleChange}
                    />
                    <span className={styles.text}>{item.label}</span>
                </label>
            ))}
        </div>
    );
}
